import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AddressListComponent } from "./address/address-list/address-list.component";
import { GetDataComponent } from "./get-data/get-data.component";

const routes: Routes = [
  {
    path: "endereco",
    component: AddressListComponent,
  },
  {
    path: "get-data",
    component: GetDataComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProfileRoutingModule {}
